import { IFindJobsFilter } from '../../types/findJobsType'

/**
 * The `buildQueryParams` function takes in a filter object and builds a query string by removing any
 * undefined, null, or empty values and joining array values with a tilde (~).
 * @param {IFindJobsFilter} filter - The `filter` parameter is an object that contains various
 * properties used to filter job search results. The properties include:
 * @returns a string that represents the query parameters based on the provided filter object.
 */
export const buildQueryParams = (filter: IFindJobsFilter) => {
  const queryParams: { [key: string]: any } = {
    search: filter.search,
    location: filter.location,
    category: filter.category,
    jobType: filter.jobType,
    workplace: filter.workplace,
    career_level: filter.career_level,
    date_posted: filter.date_posted,
    page: filter.page,
    resume_id: filter.resume_id,
  }

  for (const key in queryParams) {
    if (
      queryParams[key] === undefined ||
      queryParams[key] === null ||
      queryParams[key] === ''
    ) {
      delete queryParams[key]
    }
    if (queryParams[key] instanceof Array) {
      if (queryParams[key].length === 0) {
        delete queryParams[key]
      } else {
        queryParams[key] = queryParams[key].join('~')
      }
    }
  }
  const queryString = new URLSearchParams(queryParams).toString()

  return queryString
}

// Read from the URL and set the filter state
export const parseURL = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const search = urlParams.get('search')
  const location = urlParams.get('location')
  const category = urlParams.get('category')
  const jobType = urlParams.get('jobType')
  const workplace = urlParams.get('workplace')
  const career_level = urlParams.get('career_level')
  const date_posted = urlParams.get('date_posted')
  const page = urlParams.get('page')
  const resume_id = urlParams.get('resume_id')

  const result: { [key: string]: any } = {}

  if (search) result.search = search
  if (location) result.location = location
  if (category) result.category = +category
  if (jobType) {
    result.jobType = jobType.split('~')
  }
  if (workplace) {
    result.workplace = workplace.split('~')
  }
  if (career_level) {
    result.career_level = career_level.split('~')
  }
  if (date_posted) {
    result.date_posted = date_posted
  }
  if (page) {
    result.page = +page
  }
  if (resume_id) {
    result.resume_id = resume_id
  }

  return result
}
